function MaintenancePage({ onUnlockPreview }) {
  return (
    <main className="relative z-10 min-h-screen flex items-center justify-center px-4 py-24">
      <section className="hero-card max-w-3xl w-full mx-auto p-8 md:p-12 text-left">
        <p className="uppercase tracking-[0.2em] text-xs md:text-sm font-bold text-cyan-700 mb-4">
          Wartungsmodus
        </p>

        <h1 className="text-4xl md:text-6xl font-black text-slate-900 leading-tight max-w-2xl">
          Website ist gerade in Arbeit.
        </h1>

        <p className="mt-5 text-base md:text-lg text-slate-700 leading-relaxed max-w-2xl">
          Diese Seite wird momentan überarbeitet. Sobald alles fertig ist, ist die normale Website wieder online.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
          <a
            href="mailto:markopiljak@web.de"
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm md:text-base font-semibold text-white shadow-lg shadow-slate-900/15 transition-transform hover:-translate-y-0.5"
          >
            Kontakt per E-Mail
          </a>

          <div className="text-sm md:text-base text-slate-600">
            Für aktuelle Anfragen bitte direkt per Mail melden.
          </div>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          <div className="glass-card p-4 text-slate-700">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-cyan-700 mb-2">Status</p>
            <p>Website wird technisch und optisch vorbereitet.</p>
          </div>
          <button
            type="button"
            onClick={onUnlockPreview}
            className="glass-card p-4 text-slate-700 text-left focus:outline-none focus:ring-2 focus:ring-cyan-400"
          >
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-cyan-700 mb-2">Optik</p>
            <p>Die Seite bleibt im Stil der bestehenden Website.</p>
          </button>
            
          
          <div className="glass-card p-4 text-slate-700">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-cyan-700 mb-2">Hinweis</p>
            <p>Hier erscheint vorübergehend nur diese Information.</p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default MaintenancePage;
